<template>
  <main>
    <div class="common-report qtime-activity-view">
      <div>
        <div>
          <qtime-report-header></qtime-report-header>
          <team-overview-relation></team-overview-relation>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TeamOverviewRelation from "./team-overview/TeamOverviewRelation";
const QtimeReportHeader = () => import("./QtimeReportHeader");
export default {
  name: "TeamOverview",
  components: { TeamOverviewRelation, QtimeReportHeader },
  computed: {
    // filter: function() {
    //   return this.$store.state.reports.qcentrisCountryTurnoverFilter;
    // }
  },
  beforeMount() {
    //this.fetchData();
  },
  methods: {
    // fetchData: function() {
    //   this.$store.dispatch("fetchCountryTurnover", this.filter);
    //   this.$store.dispatch("fetchReportAggregates");
    // }
  }
};
</script>

<style scoped>
.qtime-activity-view {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}
</style>